import { createReducer, on } from '@ngrx/store';

import type { CdnInfo, MemberAreaUser } from '@common/types/user.type';
import { type EduUser, type LandingPageUser } from '@common/types/user.type';

import * as UserActions from './user.actions';

export const USER_FEATURE_KEY = 'user';

export type UserState = {
    user: LandingPageUser;
    loaded: boolean;
    error?: string;
    eduUser: EduUser;
    eduUserLoaded: boolean;
    eduUserError?: string;
    cdnInfo?: CdnInfo;
    memberAreaUser: MemberAreaUser;
    memberAreaUserError?: string;
};

export const initialUserState: UserState = {
    user: null,
    loaded: false,
    error: null,
    eduUser: null,
    eduUserLoaded: false,
    eduUserError: null,
    cdnInfo: null,
    memberAreaUser: null,
    memberAreaUserError: null,
};

export const userReducer = createReducer<UserState>(
    initialUserState,
    on(UserActions.loadUserSuccess, (state: UserState, { user }) => ({ ...state, user, loaded: true })),
    on(UserActions.loadEduUserSuccess, (state: UserState, { eduUser }) => ({ ...state, eduUser, eduUserLoaded: true })),
    on(UserActions.loadUserFailure, (state: UserState, { error }) => ({ ...state, error })),
    on(UserActions.loadEduUserFailure, (state: UserState, { eduUserError }) => ({ ...state, eduUserError })),
    on(UserActions.setUserCdnInfo, (state: UserState, { cdnInfo }) => ({ ...state, cdnInfo })),
    on(UserActions.loadMemberAreaUserFailure, (state: UserState, { memberAreaUserError }) => ({
        ...state,
        memberAreaUserError,
    })),
    on(UserActions.loadMemberAreaUserSuccess, (state: UserState, { memberAreaUser }) => ({
        ...state,
        memberAreaUser,
        loaded: true,
    }))
);
